import { render, staticRenderFns } from "./WvSteakHouseDefaultSection.vue?vue&type=template&id=ca5250a4&scoped=true"
import script from "./WvSteakHouseDefaultSection.vue?vue&type=script&lang=ts"
export * from "./WvSteakHouseDefaultSection.vue?vue&type=script&lang=ts"
import style0 from "./WvSteakHouseDefaultSection.vue?vue&type=style&index=0&id=ca5250a4&prod&lang=css"
import style1 from "./WvSteakHouseDefaultSection.vue?vue&type=style&index=1&id=ca5250a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca5250a4",
  null
  
)

export default component.exports